const urlencode = str => {
  /* the built-in encodeURIComponent() javascript method
  does not encode some characters that are encoded by the
  built-in urlencode() PHP method. This had to be solved
  for the Hermes signup form where user enters an
  invitation code that can be any character.
   */
  return encodeURIComponent(str + '')
    .replace(/%20/g, '+')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/\*/g, '%2A')
    .replace(/'/g, '%27')
    .replace(/~/g, '%7E')
    .replace(/!/g, '%21');
};

export default urlencode;
